import { useEffect, useState } from "react";
import { ReportsChart, StatisticCard, StatisticTable } from "./ReportsViews";
import { FaUser } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { FaMoneyBill } from "react-icons/fa";
import { TbArrowsUpDown } from "react-icons/tb";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import axios from "axios";
import _ from "lodash";
import filterFactory, {
  textFilter,
  numberFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import Button from "react-bootstrap/Button";

const BrokerageView = (props) => {
  const brokerage = props.brokerage;
  const prospects = props.brokerage.prospects;
  const [brokerageReportData, setBrokerageReportData] = useState({});
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState("brokers");
  const [tableInfo, setTableInfo] = useState([]);
  const [chartData, setChartData] = useState();
  const [prospectsCharts, setProspectsCharts] = useState();
  const [transactionCharts, setTransactionCharts] = useState();
  const [prospectModal, setProspectModal] = useState(false);
  const [bindChart, setBindChart] = useState();
  useEffect(() => {
    delete brokerage.prospects;

    axios
      .post(
        process.env.REACT_APP_BASICSERVICE +
          "/api/brokerages/getBrokerageReport",
        brokerage
      )
      .then((response) => {
        var tempReportData = response.data;

        tempReportData["brokers"] = joinData(
          tempReportData.brokers,
          tempReportData.transactions,
          "transactions",
          "_id",
          "userid"
        );

        tempReportData["prospects"] = joinData(
          tempReportData.prospects,
          tempReportData.transactions,
          "transactions",
          "_id",
          "prospectid"
        );

        tempReportData["prospects"] = joinData(
          tempReportData.prospects,
          tempReportData.brokers,
          "broker",
          "userid",
          "_id"
        );

        setBrokerageReportData(tempReportData);

        const tempCard = [
          //   { icon: FaBuilding, title: "Brokerages", data: brokeragesList.length },
          {
            icon: FaUser,
            title: "Brokers",
            data: brokerage.active_brokers.length,
            view: "brokers",
          },
          {
            icon: TbArrowsUpDown,
            title: "Total Transactions",
            data: tempReportData.transactions.length,
            view: "transactions",
          },
          {
            icon: FaUserFriends,
            title: "Total Prospects",
            data: tempReportData.prospects.length,
            view: "prospects",
          },
        ];

        setCards(tempCard);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  useEffect(() => {
    // Convert timestamps to dates and sort data by date
    const sortedData = _.sortBy(
      brokerageReportData.transactions,
      (d) => new Date(d.usertime)
    );

    // Group data by date
    const groupedData = _.groupBy(sortedData, (d) =>
      new Date(d.usertime).toLocaleDateString()
    );

    // Create labels array (unique dates)
    const labels = Object.keys(groupedData);

    // Create datasets array
    const datasets = [];
    for (let date of labels) {
      const counts = _.countBy(groupedData[date], "tostatus");
      for (let status of Object.keys(counts)) {
        let dataset = datasets.find((d) => d.label === status);
        if (!dataset) {
          dataset = {
            label: status,
            data: new Array(labels.length).fill(0), // initialize data array with zeros
          };
          datasets.push(dataset);
        }
        dataset.data[labels.indexOf(date)] = counts[status];
      }
    }

    setChartData({ labels, datasets });
  }, [brokerageReportData]);

  useEffect(() => {
    const groupKeyGetterProspects = (item) =>
      _.get(item, "answers.operations.list[0].vertical.name.en");

    const groupKeyGetterTransactions = (item) => {
      const date = new Date(item.usertime);
      return date.toLocaleDateString(); // Convert to a string in the format 'MM/DD/YYYY'
    };

    setProspectsCharts(
      preparePieChartData(
        brokerageReportData.prospects,
        groupKeyGetterProspects
      )
    );

    setChartData(
      prepareChartData(
        brokerageReportData.transactions,
        groupKeyGetterTransactions,
        "tostatus"
      )
    );

    const prospectBinds = countLabelsAndBindings(
      brokerageReportData.prospects,
      (item) => _.get(item, "answers.operations.list[0].name.en"),
      (item) => item.isbinded
    );
    setBindChart(prospectBinds);
  }, [brokerageReportData]);

  const prepareChartData = (data, groupKeyGetter, statusField) => {
    // Sort data by group key
    const sortedData = _.sortBy(data, groupKeyGetter);

    // Group data by group key
    const groupedData = _.groupBy(sortedData, groupKeyGetter);

    // Create labels array (unique group keys)
    const labels = Object.keys(groupedData);

    // Create datasets array
    const datasets = [];
    for (let groupKey of labels) {
      const counts = _.countBy(groupedData[groupKey], statusField);
      for (let status of Object.keys(counts)) {
        let dataset = datasets.find((d) => d.label === status);
        if (!dataset) {
          dataset = {
            label: status,
            data: new Array(labels.length).fill(0), // initialize data array with zeros
          };
          datasets.push(dataset);
        }
        dataset.data[labels.indexOf(groupKey)] = counts[status];
      }
    }

    return { labels, datasets };
  };

  function preparePieChartData(list, keyGetter) {
    // Group data by key
    const groupedData = _.groupBy(list, keyGetter);

    // Create labels array (unique keys)
    const labels = Object.keys(groupedData);

    // Create data array (counts of each key)
    const data = labels.map((label) => groupedData[label].length);

    // Create color array (random colors for each key)
    const backgroundColors = labels.map(
      () => "#" + Math.floor(Math.random() * 16777215).toString(16)
    );

    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: backgroundColors,
        },
      ],
    };
  }

  function prepareInsurerCounts(data, names) {
    const counts = {};

    for (const name of names) {
      counts[name] = 0;
    }

    for (const item of data) {
      for (const name of names) {
        if (item.fromstatus.includes(name)) {
          counts[name]++;
        }
      }
    }

    return names.map((name) => ({
      name,
      amount: counts[name],
    }));
  }

  function prepareInsurerCountsForChart(data, names) {
    const counts = {};

    for (const name of names) {
      counts[name] = 0;
    }

    for (const item of data) {
      for (const name of names) {
        if (item.fromstatus.includes(name)) {
          counts[name]++;
        }
      }
    }

    return {
      labels: names,
      datasets: [
        {
          label: "Insurer Count",
          data: names.map((name) => counts[name]),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
      ],
    };
  }

  function countLabelsAndBindings(list, labelGetter, isBindedGetter) {
    const groupedData = _.groupBy(list, labelGetter);
    const labels = Object.keys(groupedData);

    return labels.map((label) => {
      const itemsWithLabel = groupedData[label];
      const totalCount = itemsWithLabel.length;
      const bindCount = itemsWithLabel.filter(isBindedGetter).length;

      return {
        vertical: label,
        count: totalCount,
        bindCount,
      };
    });
  }

  function joinData(list1, list2, objectName, field1 = "_id", field2 = "_id") {
    return _.map(list1, (item1) => {
      const item1Matches = _.filter(list2, { [field2]: item1[field1] });

      return {
        ...item1,
        [objectName]: item1Matches,
      };
    });
  }

  return (
    <>
      <Col>
        <Button
          onClick={() => {
            props.navigateBack();
          }}
          variant="link"
        >
          Back
        </Button>
        <Row>
          {cards.map((cardInfo) => {
            return (
              <StatisticCard
                cardInfo={cardInfo}
                selectedCard={selectedCard}
                setSelectedCard={(card) => setSelectedCard(card)}
              />
            );
          })}
        </Row>

        <Row>
          {/* //brokers */}
          {selectedCard === "brokers" && !_.isEmpty(brokerageReportData) && (
            // <Col md={12}>
            //   <StatisticTable
            //     keyField={"firstname"}
            //     data={brokerageReportData.brokers}
            //     headers={[
            //       { label: "First Name", field: "firstname", type: "string" },
            //       // { label: "Code", field: "code", type: "string" },
            //       // { label: "Website", field: "website", type: "string" },
            //       // { label: "Contact Number", field: "contact_number", type: "string" },
            //       {
            //         label: "Role",
            //         field: "jobrole",
            //         type: "text",
            //       },
            //       {
            //         label: "Location",
            //         field: "location",
            //         type: "string",
            //       },
            //       {
            //         label: "Transactions",
            //         field: "transactions",
            //         type: "array",
            //       },
            //     ]}
            //     itemsPerPage={5}
            //     //   handleRowClick={(data) => handleClick(data)}
            //   />
            // </Col>
            <Col md={12}>
              <StatisticTable
                keyField={"user._id"}
                data={brokerageReportData.brokers}
                headers={[
                  {
                    text: "Id",
                    dataField: "user._id",

                    hidden: true,
                    sort: true,
                  },
                  {
                    text: "First Name",
                    dataField: "firstname",
                    type: "string",
                    sort: true,
                  },
                  {
                    text: "Role",
                    dataField: "jobrole",
                    type: "text",
                    sort: true,
                  },
                  {
                    text: "Location",
                    dataField: "location",
                    type: "string",
                    sort: true,
                  },
                  // {
                  //   text: "Transaction",
                  //   dataField: "transactions",
                  //   type: "array",
                  //   sort: true,
                  // },
                ]}
                itemsPerPage={5}
                // handleRowClick={(data) => props.brokerageRowClick(data)}
              />
            </Col>
          )}
          <Col>
            {selectedCard === "transactions" && chartData && (
              <ReportsChart reportData={chartData} reportChartType="BAR" />
            )}
          </Col>
          {selectedCard === "prospects" && !_.isEmpty(brokerageReportData) && (
            <>
              <Col md={12}>
                <StatisticTable
                  keyField={"_id"}
                  data={brokerageReportData.prospects}
                  headers={[
                    {
                      text: "ID",
                      dataField: "_id",
                      type: "string",
                      hidden: true,
                    },
                    // {
                    //   text: "Vertical",
                    //   dataField: "answers.operations.list[0].name.en",
                    //   type: "string",
                    //   filter: textFilter(),
                    // },
                    {
                      text: "Vertical",
                      dataField: "answers.operations.list[0].name.en",
                      type: "string",
                      //   formatter: (cell) => {
                      //     return (
                      //       bindChart.filter((opt) => opt === cell)[0]
                      //         .vertical || ""
                      //     );
                      //   },
                      filter: selectFilter({
                        options: () =>
                          bindChart.map((data) => {
                            return {
                              value: data.vertical,
                              label: data.vertical,
                            };
                          }),
                      }),
                    },
                    {
                      text: "Binded",
                      dataField: "isbinded",
                      type: "boolean",
                      formatter: (cellContent, row) => {
                        return row.isbinded ? "Yes" : "No";
                      },
                    },

                    {
                      type: "string",
                      dataField: "status",
                      text: "Status",
                    },
                    // {
                    //   text: "Product Code",
                    //   dataField: "answers.productcode",
                    //   type: "string",
                    // },
                    {
                      text: "Transactions",
                      dataField: "transactions.length",
                      type: "array",
                      filter: numberFilter(),
                    },
                    {
                      text: "Broker",
                      dataField: "broker[0].firstname",
                      type: "string",
                      filter: textFilter(),
                    },
                  ]}
                  itemsPerPage={5}
                  // handleRowClick={(data) => {
                  //   setProspectModal(true);
                  //   handleClick(data);
                  // }}
                />
              </Col>
              <Col md={12}>
                <StatisticTable
                  keyField={"label"}
                  data={bindChart}
                  headers={[
                    {
                      text: "Vertical",
                      dataField: "vertical",
                      type: "string",
                      formatter: (cell) => {
                        return (
                          bindChart.filter((opt) => opt.vertical === cell)[0]
                            .vertical || ""
                        );
                      },
                      filter: selectFilter({
                        options: () =>
                          bindChart.map((data) => {
                            return {
                              value: data.vertical,
                              label: data.vertical,
                            };
                          }),
                      }),
                    },
                    {
                      text: "Vertical Count",
                      dataField: "count",
                      type: "number",
                      filter: numberFilter(),
                    },

                    {
                      text: "Binds",

                      dataField: "bindCount",
                      type: "string",
                      filter: numberFilter(),
                    },
                  ]}
                  itemsPerPage={5}
                  // handleRowClick={(data) => {
                  //   setProspectModal(true);
                  //   handleClick(data);
                  // }}
                />
              </Col>
              <Col md={12}>
                <ReportsChart
                  reportData={prospectsCharts}
                  reportChartType="PIE"
                  reportTitle="Prospects Breakdown"
                />
              </Col>
            </>
          )}
        </Row>
      </Col>
    </>
  );
};

export default BrokerageView;
